import { RootRouteEnum } from '../router/@types';

/**
 * Left Navigation Bar에서 사용하는 모든 UI 라벨
 */
export const LNB_LABELS = {
  HOME: 'Home',
  ANALYTICS: 'Analytics',
  PORTFOLIO: 'Portfolio',
  MARKETPLACE: 'Marketplace',
  SOCIAL_MEDIA: 'Social Media',
  WEBSITE_CONTENT: 'Website Content',
  DOMAIN_NAMES: 'Domain Names',
  SELLER_MANAGEMENT: 'Seller Management',
  SELLER_MATCH: 'Seller Match',
  SELLER_INTEL: 'Seller Intel',
  AI_CONTENT_TAKEDOWN: 'AI Content Takedown',
  CONVERSATIONAL_ASSISTANT: 'Conversational Assistant',
  PRICE_MONITORING: 'Price Monitoring',
} as const;

/**
 * RootRouteEnum과 UI Label 매핑
 * MARQ_AI_LNB에서 사용
 */
export const ROOT_ROUTE_LABELS: Record<RootRouteEnum, string> = {
  [RootRouteEnum.Home]: LNB_LABELS.HOME,
  [RootRouteEnum.Analytics]: LNB_LABELS.ANALYTICS,
  [RootRouteEnum.Portfolio]: LNB_LABELS.PORTFOLIO,
  [RootRouteEnum.Marketplace]: LNB_LABELS.MARKETPLACE,
  [RootRouteEnum.SocialMedia]: LNB_LABELS.SOCIAL_MEDIA,
  [RootRouteEnum.WebsiteContent]: LNB_LABELS.WEBSITE_CONTENT,
  [RootRouteEnum.DomainNames]: LNB_LABELS.DOMAIN_NAMES,
  [RootRouteEnum.SellerAnalytics]: LNB_LABELS.SELLER_MANAGEMENT,
  [RootRouteEnum.SellerLink]: LNB_LABELS.SELLER_MATCH,
  [RootRouteEnum.SellerIntel]: LNB_LABELS.SELLER_INTEL,
  [RootRouteEnum.GenerativeAI]: LNB_LABELS.AI_CONTENT_TAKEDOWN,
  [RootRouteEnum.ConversationalAssistant]: LNB_LABELS.CONVERSATIONAL_ASSISTANT,
  [RootRouteEnum.PriceMonitoring]: LNB_LABELS.PRICE_MONITORING,
  [RootRouteEnum.Login]: '',
  [RootRouteEnum.Auth]: '',
  [RootRouteEnum.Okta]: '',
  [RootRouteEnum.Dashboard]: '',
  [RootRouteEnum.ResetPassword]: '',
  [RootRouteEnum.VerifyEmail]: '',
  [RootRouteEnum.Signup]: '',
  [RootRouteEnum.Callback]: '',
  [RootRouteEnum.Settings]: '',
};
